import { createRef } from '@wix/materializer'

export const envRefs = {
	renderScrollSnap: createRef<boolean>(['environment', 'renderFlags', 'renderScrollSnap']),
	renderSticky: createRef<boolean>(['environment', 'renderFlags', 'renderSticky']),
	experiment: (experiment: string) => createRef<boolean>(['environment', 'experiments', experiment]),
	// Where this should be?
	isMobileView: createRef<boolean>(['environment', 'mobile', 'isMobileView']),
}
